import { render } from "./ReportInventoryReceiving.vue?vue&type=template&id=b44ffcd0&scoped=true"
import script from "./ReportInventoryReceiving.vue?vue&type=script&lang=js"
export * from "./ReportInventoryReceiving.vue?vue&type=script&lang=js"

import "./ReportInventoryReceiving.vue?vue&type=style&index=0&id=b44ffcd0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b44ffcd0"]])

export default __exports__